import { OfficeList } from './OfficeList';

export const OfficeListMember = () => <OfficeList readOnly onSave={async () => null} />;
